import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { Device, Tag } from "../../interfaces/EndpointInterfaces";
import { Role, UserVerification } from "../interface";
import { getAllTags, searchTagsForPicker } from "../../Tags/Api/tagdetailsapi";


export const fetchPendingUsers = async (tenantName: string): Promise<UserVerification[]> => {
    const url = `${NGROK}/api/invite/pending?tenantName=${tenantName}`;
    const data = await apiClient<UserVerification[]>({
        method: "GET",
        url,
    });
    return data;
}


export const fetchAllRoles = async (tenantName: string): Promise<Role[]> => {
    const url = `${NGROK}/api/${tenantName}/role-details`;
    const data = await apiClient<Role[]>({
        method: "GET",
        url,
    });
    return data;
}
export const fetchAllDevices = async (tenantName: string): Promise<Device[]> => {
    const url = `${NGROK}/api/${tenantName}/getAllUserMachines`;
    const data = await apiClient<Device[]>({
        method: "GET",
        url,
    });
    return data;
}

export const getTags = async (tenantName: string, searchTags = ""): Promise<Tag[]> => {
    const response = await searchTagsForPicker(tenantName, searchTags, 0);
    return response?.content ?? [];
};
export const sentInvite = async (payload: any) => {
    let url = `${NGROK}/api/invite/send`
    const response = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return response;
}

export const revokeInvitation = async (tenantName: string, email: string) => {
    const url = `${NGROK}/api/invite/revoke?tenantName=${encodeURIComponent(tenantName)}&email=${encodeURIComponent(email)}`;
    return apiClient<{ isOk: boolean; errorMessage?: string }>({
        method: "POST",
        url,
    });
};

export const deleteInvitation = async (tenantName: string, email: string) => {
    const url = `${NGROK}/api/invite/delete?tenantName=${encodeURIComponent(tenantName)}&email=${encodeURIComponent(email)}`;
    return apiClient<{ isOk: boolean; errorMessage?: string }>({
        method: "DELETE",
        url,
    });
};
